<template>
  <div class="login-container">
    <p class="title">查询登录</p>
    <van-cell-group>
      <van-field v-model="userId" label="用户名" />
      <van-field v-model="password" label="密码" type="password" />
      <van-button size="large" type="primary" @click="onSure">登录</van-button>
    </van-cell-group>
    <div class="list" v-if="listUrl.length">
      <p>网址书签</p>
      <div v-for="(item,index) in listUrl" :key="index">
        <p class="list-item-title">{{ item.title }}</p>
        <div class="list-item-url" @click="onUrlClick(item.linkUrl)">
          <p>{{ item.linkUrl }}</p>
        </div>
      </div>
      

    </div>
  </div>
</template>

<script>
import { setCookie } from "../../utils/cookies";

export default {
  name: "Index",
  data() {
    return {
      userId: '',
      password: '',
      url: 'http://h5.rolormd.com/7999/Arongleweb/html/lucky/index.html',
      listUrl:[],
    }
  },
  methods: {
    onSure() {
      if (this.userId && this.password) {
        this.get("/Base/PublicTools/SpecialLogin?", { phone: this.userId, password: this.password },2).then((json) => {
          if (json.code === 1) {
            this.$toast('登陆成功');
            if (json.response) {
              setCookie("token", json.response.userInfo.token)
              setCookie("E", json.response.userInfo.token);
              localStorage.setItem("token", json.response.userInfo.token)
              localStorage.setItem("E", json.response.userInfo.token)
              // this.$router.push("/")
              this.listUrl = json.response.linkUrl;
            }
          } else {
            this.$toast(json.msg);
            this.listUrl = [];
          }
        },3);
      }
    },
    onUrlClick(url) {
      window.open(url);
      // window.location.href = url;
    }
  }
}
</script>

<style scoped>
.login-container {
  padding: 20px;
}
.van-field {
  background-color: #f8f8f8 !important;
  margin-bottom: 10px !important;
}
.van-cell::after {
  border-bottom: none !important;
}
.van-button {
  margin-top: 20px;
}
.title {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  line-height: 60px;
}
.list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 20px;
  font-size: 16px;
}
.list div{
  text-align: left;
}
.list-item-title{
  padding: 10px 0 4px;
  font-size: 14px;
}
.list-item-url{
  border-bottom: 1px solid #f8f8f8;
  width: 100%;
  padding-bottom: 10px;
  text-align: left;
}
.list-item-url p {
  word-break: break-all;
  word-wrap: break-word;
  white-space: normal;
  line-height: 1.4;
  color: rgb(109, 109, 235);
}
</style>
